// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3n_7Z","footer":"styles_footer__2Hisb"};